export enum ChatErrorType {
  Unknown = "unknown",
  RoomNotFound = "room not found",
}
